import { getUserInfo } from "@/services/api_user";
import { IUserInfo } from "@/types/user";
import { create } from "zustand";

// 模块级计时器，确保单例运行
let pwdFreezeTimerId: NodeJS.Timeout | null = null;

const userInfoState: IUserInfo = {
  userId: "",
  displayName: "",
  mobile: "",
  avatar: "",
  firstRecord: true,
  company: {
    identityId: "",
    identityType: 0,
    avatar: "",
    realname: "",
    companyName: "",
    shortName: "",
    companyId: "",
    companyCode: "",
  },
  formatUserName: "",
  switchOrg: true,
};

export const getUser = async (refresh: boolean = false): Promise<boolean> => {
  try {
    const isFirst = userInfoStore.getState().firstRecord;
    console.log('getUser', isFirst, refresh);
    if (isFirst || refresh) {
      const info = await getUserInfo();
      userInfoStore.getState().updateUser({ ...info, firstRecord: false });
    }
    return true;
  } catch (e) {
    console.error(e);
    return false;
  }
};

interface UserInfoStore extends IUserInfo {
  updateUser: (info: IUserInfo) => void;
  updateRecordFlag: (isFirst: boolean) => void;
  resetUser: () => void;
  updateUserInfo: (info: Partial<IUserInfo>) => void;
  // 密码冻结相关
  pwdFreezeCountDown: number;
  pwdErrorCount: number;
  startPwdFreeze: () => void;
  incrementPwdError: () => boolean;
  resetPwdFreeze: () => void;
}

const userInfoStore = create<UserInfoStore>((set, get) => ({
  // 合规要求，不存储用户信息，每次进来都获取一次吧
  ...userInfoState,
  updateUser: (info: IUserInfo) => {
    set(info);
  },
  updateUserInfo: (info: Partial<IUserInfo>) => {
    set(info);
  },
  updateRecordFlag: (isFirst: boolean) => {
    set({ firstRecord: isFirst });
  },
  resetUser: () => {
    set(userInfoState);
    localStorage.removeItem("userInfo");
  },
  // 密码冻结相关状态
  pwdFreezeCountDown: 0,
  pwdErrorCount: 0,
  // 启动密码冻结倒计时
  startPwdFreeze: () => {
    if (pwdFreezeTimerId) clearInterval(pwdFreezeTimerId);
    set({ pwdFreezeCountDown: 60 });
    pwdFreezeTimerId = setInterval(() => {
      const { pwdFreezeCountDown } = get();
      if (pwdFreezeCountDown <= 1) {
        if (pwdFreezeTimerId) clearInterval(pwdFreezeTimerId);
        pwdFreezeTimerId = null;
        set({ pwdFreezeCountDown: 0, pwdErrorCount: 0 });
      } else {
        set({ pwdFreezeCountDown: pwdFreezeCountDown - 1 });
      }
    }, 1000);
  },
  // 增加密码错误次数，返回是否触发冻结
  incrementPwdError: () => {
    const newCount = get().pwdErrorCount + 1;
    set({ pwdErrorCount: newCount });
    if (newCount >= 3) {
      get().startPwdFreeze();
      return true;
    }
    return false;
  },
  // 重置密码冻结状态
  resetPwdFreeze: () => {
    if (pwdFreezeTimerId) clearInterval(pwdFreezeTimerId);
    pwdFreezeTimerId = null;
    set({ pwdFreezeCountDown: 0, pwdErrorCount: 0 });
  },
}));

export default userInfoStore;
